import script from "./DashboardFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardFilter.vue?vue&type=script&setup=true&lang=js"

import "./DashboardFilter.vue?vue&type=style&index=0&id=ae0efb4a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ae0efb4a"]])

export default __exports__